import React from 'react'
import {APPROVAL_STATUS_OPTIONS, IXmlTariffModel} from '../xml-tariff/XmlTariffModel'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'
import { formatDate } from '../../../utils/DateUtil'
import { getSelectLabel } from '../../../../shared/models/SharedConstantLookups'

type Props = {
  data: IXmlTariffModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onApprove?: (xmlTariff: IXmlTariffModel) => void
  onReject?: (xmlTariff: IXmlTariffModel) => void
  onDetail?: (xmlTariff: IXmlTariffModel) => void
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const XmlTariffApprovalTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onApprove,
  onReject,
  onDetail,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const columns: TableColumn<IXmlTariffModel>[] = [
    {key: 'rateName', label: 'Tarife Adı', className: 'fw-semibold', sortable: true},
    {key: 'startDate', label: 'Başlangıç Tarihi', sortable: true, render: (v) => formatDate(v)},
    {key: 'endDate', label: 'Bitiş Tarihi', sortable: true, render: (v) => formatDate(v)},
    {key: 'actionDate', label: 'İşlem Tarihi', sortable: true, render: (v) => formatDate(v)},
    {key: 'approvalStatus', label: 'Onay Durumu', sortable: true, render: (v) => getSelectLabel(APPROVAL_STATUS_OPTIONS, v)}, 
  ]

  const actions: TableAction<IXmlTariffModel>[] = [
    {
      label: 'Detay',
      icon: 'bi bi-eye',
      className: 'btn-light-info me-2',
      onClick: (item) => onDetail?.(item),
    },
    {
      label: 'Onayla',
      icon: 'bi bi-check-circle',
      className: 'btn-light-success me-2',
      onClick: (item) => onApprove?.(item),
    },
    {
      label: 'Reddet',
      icon: 'bi bi-x-circle',
      className: 'btn-light-danger',
      onClick: (item) => onReject?.(item),
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Onay bekleyen tarife bulunamadı'
    />
  )
}
